// https://webpack.js.org/guides/dependency-management/#require-context
const requireIcons = require.context('.', false, /.svg/);

type IconsMap = {
  [k: string]: string;
};

export const iconsMap: IconsMap = requireIcons
  .keys()
  .reduce((icons, filepath): { [iconName: string]: string } => {
    const iconName = filepath.replace('./', '').replace('.svg', '');
    return {
      ...icons,
      [iconName]: filepath,
    };
  }, {});
